// @flow
import * as React from "react";
import styles from "./modal.scss";
import Loader from "../loader/loader";

const closeIcnUrl = require("../../../assets/images/close_icn.svg");
const closeIcnWhiteUrl = require("../../../assets/images/close_icn_white.svg");
const backIcnWhiteUrl = require("../../../assets/images/back_icn.svg");

type Props = {
  children?: React.Node,
  showModal?: boolean,
  title?: any,
  closeModal: Function,
  showLoader?: boolean,
  modalTheme?: Object,
  onBackBtnClick?: Function
};

const Modal = (props: Props) =>
  props.showModal ? (
    <div
      className={` ${
        props.modalTheme && props.modalTheme.name
          ? styles[props.modalTheme.name]
          : ""
      } ${styles.modalWrapper} modal-wrapper l-row j-center a-center`}
    >
      <div className={` ${styles.modalParent} modal-parent`}>
        {props.showLoader ? (
          <div className={` ${styles.loaderParent} `}>
            <Loader />
          </div>
        ) : null}

        <div className={`${styles.modalHeader} l-row j-space-bet`}>
          {props.modalTheme && props.modalTheme.showBackBtn ? (
            <div
              className={`${styles.backBtnWrapper} l-row a-center back-btn-wrapper`}
              onClick={() => props.onBackBtnClick && props.onBackBtnClick()}
            >
              <div className={`${styles.backIcn} l-row a-center`}>
                <img src={backIcnWhiteUrl} alt="" />{" "}
              </div>
              <div className="back-btn-label l-row a-center">BACK</div>
            </div>
          ) : null}
          {props.modalTheme &&
          props.modalTheme.titleCenter &&
          !props.modalTheme.showBackBtn ? (
            <div className={`${styles.dummyDivToKeepTitleInCenter}`}>---</div>
          ) : null}

          <div className={`${styles.modalTitle} l-row a-center`}>
            {props.title}
          </div>
          <div className="l-row a-center" onClick={() => props.closeModal()}>
            <img
              className={
                props.modalTheme && props.modalTheme.closeIcnWhite
                  ? styles.modalCloseWhite
                  : styles.modalClose
              }
              src={
                props.modalTheme && props.modalTheme.closeIcnWhite
                  ? closeIcnWhiteUrl
                  : closeIcnUrl
              }
              alt="close"
            />
          </div>
        </div>

        <div className={`${styles.modalBody}`}>{props.children}</div>
      </div>
      <div className={`${styles.modalBackdrop} modal-backdrop `} />
    </div>
  ) : null;

Modal.defaultProps = {
  children: "",
  showModal: false,
  title: "Title Field",
  showLoader: false,
  modalTheme: {},
  // eslint-disable-next-line
  onBackBtnClick: () => console.log("onBackBtnClick prop Missing")
};

export default Modal;



// WEBPACK FOOTER //
// ./app/components/commons/modal/modal.js